// Словари и форматирование модуля «Спецификации и комплектация» (ТЗ 2.2–2.6, 9.6).
// Только чистые функции: тексты кодов, деньги, проценты, срок поставки словами.
// Сгенерировано Claude.

/** Категории позиций (ТЗ 2.3), порядок по умолчанию — как перечислено. */
export const CATEGORIES = {
  floors: 'Полы',
  furniture: 'Мебель',
  light: 'Свет',
  plumbing: 'Сантехника',
  textile: 'Текстиль',
  decor: 'Декор',
  finishing: 'Отделочные материалы',
  appliances: 'Бытовая техника',
};

/** Единицы измерения (ТЗ 2.2). */
export const UNITS = {
  pcs: 'шт.',
  m2: 'м²',
  rm: 'п.м.',
  set: 'компл.',
  pack: 'упак.',
};

/** Статусы позиции словами дизайнера (ТЗ 2.5). */
export const ITEM_STATUSES = {
  new: 'Новая',
  requested: 'Запрос отправлен',
  has_offers: 'Есть отклики',
  rework: 'На доработке',
  customer_review: 'На согласовании у заказчика',
  customer_approved: 'Утверждено заказчиком',
  customer_rejected: 'Отклонено заказчиком',
  supplier_confirmed: 'Согласовано поставщиком',
  contract: 'Договор',
  ordered: 'Заказано',
  paid: 'Оплачено',
  delivered: 'Доставлено',
  accepted: 'Принято',
};

/**
 * Статусы позиции словами заказчика (ТЗ 6.6): статусы подбора (`new`…`rework`) показываются одним
 * словом «Подбор», остальные — своими словами, «На согласовании у заказчика» у заказчика короче.
 * Отдельный словарь, а не срез общего: заказчику не показывается ни то, что позиция ещё не
 * запрошена, ни то, что она на доработке у поставщика (ТЗ 3.5).
 */
export const CUSTOMER_ITEM_STATUSES = {
  new: 'Подбор',
  requested: 'Подбор',
  has_offers: 'Подбор',
  rework: 'Подбор',
  customer_review: 'На согласовании',
  customer_approved: 'Утверждено',
  customer_rejected: 'Отклонено',
  supplier_confirmed: 'Согласовано поставщиком',
  contract: 'Договор',
  ordered: 'Заказано',
  paid: 'Оплачено',
  delivered: 'Доставлено',
  accepted: 'Принято',
};

/** Состояния отклика (ТЗ 2.6). */
export const OFFER_STATES = {
  draft: 'Черновик',
  new: 'Новый',
  chosen: 'Выбран',
  lost: 'Проиграл',
  withdrawn: 'Отозван',
};

/** Статусы запроса КП (ТЗ 2.2). */
export const REQUEST_STATUSES = {
  new: 'Новый',
  viewed: 'Просмотрен',
  has_offers: 'Есть отклики',
  rework: 'На доработке',
  finished: 'Завершён',
};

/**
 * Названия полей позиции, отклика и спецификации по-русски (ТЗ 6.2 «поле», русский язык
 * интерфейса): история и список изменений отклика приходят с кодами полей, а показывать их
 * пользователю кодом нельзя. Сгенерировано Claude.
 */
export const FIELD_TITLES = {
  // отклик (ТЗ 2.2 «Отклик»)
  supplierPrice: 'цена',
  discountType: 'тип скидки',
  discountValue: 'скидка',
  deliveryTerm: 'срок',
  comment: 'комментарий',
  isReplacement: 'замена',
  replacementText: 'текст замены',
  state: 'состояние',
  // позиция (ТЗ 2.2 «Позиция»)
  name: 'наименование',
  brand: 'бренд',
  series: 'серия',
  article: 'артикул',
  colorMaterial: 'цвет / материал',
  dimensions: 'габариты',
  category: 'категория',
  room: 'помещение',
  quantity: 'количество',
  unit: 'единица',
  plannedPrice: 'плановая цена',
  designerComment: 'комментарий дизайнера',
  customerDiscount: 'скидка заказчику',
  status: 'статус',
  chosenOffer: 'выбранный отклик',
  rewardReceivedAt: 'вознаграждение получено',
  photo: 'фото',
  // спецификация
  commissionPercent: 'комиссия, %',
  customerName: 'имя заказчика',
  categoryOrder: 'порядок категорий',
};

/** Типы персональной скидки в отклике (ТЗ 2.8); единицы — как в окне разделения скидки (7.1). */
export const DISCOUNT_TYPES = {
  percent: '%',
  amount: '₽',
};

/** Типы совпадения строки КП с позицией запроса (ТЗ 5.5, 6.5). */
export const MATCH_TYPES = {
  match: 'совпадение',
  replacement: 'замена',
  none: 'нет',
};

/** Виды записей истории (ТЗ 2.2). */
export const HISTORY_KINDS = {
  field: 'правка поля',
  finance: 'финансовое поле',
  status: 'смена статуса',
  delete: 'удаление позиции',
  file: 'файлы импорта',
};

/** Уверенность распознавания строки импорта (ТЗ 5.2). */
export const CONFIDENCE = {
  high: 'высокая уверенность',
  medium: 'средняя уверенность',
  low: 'низкая уверенность',
};

/** Статусы позиции, в которых позиция уже ушла заказчику или в закупку (ТЗ 2.5). */
export const BLOCKED_FOR_REQUEST = [
  'customer_review',
  'customer_approved',
  'supplier_confirmed',
  'contract',
  'ordered',
  'paid',
  'delivered',
  'accepted',
];

/** Статусы, начиная с которых позицию нельзя удалить (ТЗ 2.5: удаление — до «Договор»). */
export const NO_DELETE_STATUSES = ['contract', 'ordered', 'paid', 'delivered', 'accepted'];

/** Статусы, из которых позицию можно вернуть в исходное состояние — «Есть отклики» (ТЗ 2.5). */
export const RESETTABLE_STATUSES = [
  'customer_review', 'customer_rejected', 'customer_approved', 'supplier_confirmed', 'contract',
];

/** Статусы закупки: позиция в ведомости (ТЗ 6.3). */
export const PURCHASE_STATUSES = ['ordered', 'paid', 'delivered', 'accepted'];

/** Следующий шаг закупки в ведомости (ТЗ 6.3). */
export const SUPPLY_NEXT = {
  ordered: 'paid',
  paid: 'delivered',
  delivered: 'accepted',
};

export function categoryTitle(code) { return CATEGORIES[code] ?? code ?? ''; }
export function unitTitle(code) { return UNITS[code] ?? code ?? ''; }
export function itemStatusTitle(code) { return ITEM_STATUSES[code] ?? code ?? ''; }
export function offerStateTitle(code) { return OFFER_STATES[code] ?? code ?? ''; }
export function customerItemStatusTitle(code) { return CUSTOMER_ITEM_STATUSES[code] ?? code ?? ''; }
export function requestStatusTitle(code) { return REQUEST_STATUSES[code] ?? code ?? ''; }
export function fieldTitle(code) { return FIELD_TITLES[code] ?? code ?? ''; }
export function discountTypeTitle(code) { return DISCOUNT_TYPES[code] ?? code ?? ''; }
export function matchTypeTitle(code) { return MATCH_TYPES[code] ?? MATCH_TYPES.none; }

/** Число из строки API («1234.56») или из ввода пользователя («1 234,56»). */
export function toNumber(value) {
  if (value === null || value === undefined || value === '') return null;
  if (typeof value === 'number') return Number.isFinite(value) ? value : null;
  const cleaned = String(value).replace(/\s/g, '').replace(',', '.');
  const parsed = parseFloat(cleaned);
  return Number.isFinite(parsed) ? parsed : null;
}

/** Арифметическое округление (половина вверх), ТЗ 7.1. */
export function round(value, digits = 2) {
  const factor = 10 ** digits;
  const shifted = value * factor;
  // сдвиг на эпсилон убирает двоичную погрешность вида 2.675 * 100 = 267.49999
  const rounded = Math.round(shifted + (shifted >= 0 ? 1e-9 : -1e-9));
  return rounded / factor;
}

/** Деньги для показа: «12 500,00 ₽» (ТЗ 9.6); пусто — тире. */
export function money(value, empty = '—') {
  const number = toNumber(value);
  if (number === null) return empty;
  const text = round(number, 2).toLocaleString('ru-RU', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return `${text} ₽`;
}

/** Деньги без знака валюты (для полей ввода и мелких ячеек). */
export function amount(value, empty = '') {
  const number = toNumber(value);
  if (number === null) return empty;
  return round(number, 2).toLocaleString('ru-RU', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

/** Проценты для показа: «-10,0 %» (ТЗ 7.1 — до 0,1). */
export function percent(value, empty = '—') {
  const number = toNumber(value);
  if (number === null) return empty;
  const text = round(number, 1).toLocaleString('ru-RU', {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  });
  return `${text} %`;
}

/** Количество: «3» или «42,5». */
export function quantity(value, empty = '') {
  const number = toNumber(value);
  if (number === null) return empty;
  return round(number, 2).toLocaleString('ru-RU', { maximumFractionDigits: 2 });
}

/** Дата «01.11.2026» из ISO-строки. */
export function date(value, empty = '') {
  if (!value) return empty;
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return empty;
  const pad = (n) => String(n).padStart(2, '0');
  return `${pad(parsed.getDate())}.${pad(parsed.getMonth() + 1)}.${parsed.getFullYear()}`;
}

/** Дата и время «01.11.2026 14:05». */
export function dateTime(value, empty = '') {
  if (!value) return empty;
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return empty;
  const pad = (n) => String(n).padStart(2, '0');
  return `${date(value)} ${pad(parsed.getHours())}:${pad(parsed.getMinutes())}`;
}

/** Варианты «В наличии» (ТЗ 2.4). */
export const STOCK_OPTIONS = {
  in_stock: 'в наличии',
  days_1_3: '1–3 дня',
  week: 'неделя',
};

/** Режимы «Под заказ» (ТЗ 2.4). */
export const ORDER_MODES = {
  days: 'дни',
  weeks: 'недели',
  text: 'текст',
  date: 'дата',
};

/** Срок поставки словами (ТЗ 2.4, 6.2). */
export function deliveryText(term, empty = '') {
  if (!term || !term.type) return empty;

  if (term.type === 'in_stock') {
    return STOCK_OPTIONS[term.stock] ?? STOCK_OPTIONS.in_stock;
  }

  const value = String(term.orderValue ?? '').trim();

  switch (term.orderMode) {
    case 'days': return value ? `${value} дней` : empty;
    case 'weeks': return value ? `${value} недель` : empty;
    case 'date': return value ? `до ${date(value)}` : empty;
    default: return value || empty;
  }
}

/**
 * Идентификатор связанной сущности из ответа API: она приходит либо объектом (`{ id, name }`),
 * либо ссылкой-строкой (`/api/suppliers/5`) — в разных операциях по-разному.
 */
export function idOf(reference) {
  if (!reference) return null;
  if (typeof reference === 'object') return reference.id ?? null;
  const match = String(reference).match(/(\d+)\s*$/);
  return match ? Number(match[1]) : null;
}

/** Помещения проекта списком названий (ТЗ 12.3: Project.objectRooms). */
export function projectRooms(project) {
  const rooms = project?.objectRooms?.rooms ?? [];
  return rooms.map((room) => room?.name).filter((name) => !!name);
}

/**
 * Итоги по набору позиций (ТЗ 7.2) — **только для групп-помещений**: свод спецификации и итоги
 * категорий приходят готовыми в ответе спецификации (`summary.total`, `summary.byCategory`) и
 * берутся оттуда. Разбивки по помещениям сервер не отдаёт, поэтому для этой группировки итоги
 * складываются здесь из уже посчитанных сервером полей позиции.
 *
 * Единственное умножение — экономия заказчика: поля «скидка заказчику по позиции» в ответе нет,
 * есть только скидка за единицу.
 */
export function summarize(items) {
  const sum = (getter) => (items ?? []).reduce((acc, item) => {
    const value = toNumber(getter(item));
    return value === null ? acc : acc + value;
  }, 0);

  const rewardTotal = sum((i) => i.designerRewardTotal);
  const commissionTotal = sum((i) => i.commissionTotal);

  return {
    plannedTotal: sum((i) => i.plannedTotal),
    customerTotal: sum((i) => i.customerTotal),
    planDeviation: sum((i) => i.planDeviation),
    savingsTotal: sum((i) => (i.chosenOffer
      ? round((toNumber(i.customerDiscount) ?? 0) * (toNumber(i.quantityFact) ?? 0), 2)
      : null)),
    rewardTotal,
    commissionTotal,
    designerIncome: round(rewardTotal + commissionTotal, 2),
  };
}

/**
 * Подсветка отклонения по готовому проценту (ТЗ 6.2): жёлтая от 10 до 25 %, красная свыше 25 %.
 * Процент по позиции отдаёт сервер (`planDeviationPercent`), на клиенте он не пересчитывается.
 */
export function deviationLevel(percentValue) {
  const share = toNumber(percentValue);
  if (share === null) return null;
  if (share > 25) return 'high';
  if (share >= 10) return 'medium';
  return null;
}

/**
 * Процент превышения цены над плановой — только для откликов под позицией (ТЗ 6.2): по откликам
 * сервер процент не отдаёт. Для самой позиции берётся `planDeviationPercent` из ответа.
 */
export function priceDeviationPercent(planned, actual) {
  const plan = toNumber(planned);
  const fact = toNumber(actual);
  if (!plan || fact === null) return null;
  return round(((fact - plan) / plan) * 100, 1);
}
